import styled from "styled-components";
import { ReactComponent as SampleIcon } from "assets/icons/new/search.svg";
import React, { useState } from "react";
import { StyledInputBase } from "common/components/Input/TextInput";
import { RowEndLayout } from "common/components/Layout/new/constLayout";
import { InputWrapper } from "common/components/Wrapper/InputBase";
import { largeComponentHeight } from "common/const/const";
import { DefaultButton } from "../Button/new/DefaultButton";
import { I18N_KEYS } from "common/i18n/keys";
import { useTranslation } from "react-i18next";

const Icon = styled.div`
  position: absolute;
  left: 12px;
  display: flex;
  align-items: center;
  pointer-events: none; /* 클릭 막기 */
`;

export const SearchInput = ({
  name = "search",
  placeholder = "Enter search text",
  onSearch,
  onReset,
  children,
  methods,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");

  const inputProps = methods?.register
    ? methods.register(name) // RHF register 사용
    : {
        value,
        onChange: (e) => setValue(e.target.value), // 로컬 state
      };

  const handleSearch = () => {
    const searchValue = methods?.getValues
      ? methods.getValues(name) // RHF 값 가져오기
      : value;
    onSearch?.(searchValue);
  };

  const handleReset = () => {
    if (methods?.resetField) {
      methods.resetField(name); // RHF 필드 리셋
    } else {
      setValue(""); // 로컬 state 리셋
    }
    onReset?.();
  };

  return (
    <div style={{ width: "100%", boxSizing: "border-box" }}>
      <RowEndLayout>
        <InputWrapper label={t(I18N_KEYS.component.tableFilter.search)}>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}>
            <Icon>
              <SampleIcon width={16} height={16} />
            </Icon>

            <StyledInputBase
              style={{ paddingLeft: "36px", boxSizing: "border-box" }}
              type="text"
              name={name}
              placeholder={placeholder}
              {...inputProps}
            />
          </div>
        </InputWrapper>

        {children}

        <div style={{ display: "flex", gap: "1rem" }}>
          <DefaultButton.Blue
            height={largeComponentHeight}
            width={"10rem"}
            onClick={handleSearch}>
            {t(I18N_KEYS.component.tableFilter.search)}
          </DefaultButton.Blue>
          <DefaultButton.White
            height={largeComponentHeight}
            style={{
              border: "1px solid var(--LightNavy)",
              color: "var(--LightNavy)",
            }}
            width={"10rem"}
            onClick={handleReset}>
            {t(I18N_KEYS.component.tableFilter.reset)}
          </DefaultButton.White>
        </div>
      </RowEndLayout>
    </div>
  );
};
